import { styled } from "@mui/material";

export const ContentContainer = styled("div")(({ theme }) => ({
  display: "flex",
  borderBottom: `0.063rem solid ${theme.palette.custom.grey["emenu-tile-active"]}`,
  padding: "0.375rem 1.25rem 0.375rem 0.5rem",
}));
